import ConstantsStorage from '../../constants/index';
import {USER_ROLE} from '../../constants/user';
import {getUnreadCountVideoPollsEmployer, getUnreadCountVideoPollsCandidate} from '../../api/video-poll.api';
import {ActionStoreServerData} from './actions-request';

const Constants = ConstantsStorage();

export function ActionPagesUpdateState(namespace, payload, remember) {
  const data = {};

  data[namespace] = payload;

  return {
    type: Constants.FLOWS_ACTIONS.UPDATE,
    data,
    remember,
  };
}

export function ActionChangeHelperState(type, helperState) {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.rUser || {};
    const userId = user._id || 'guest';
    const helperSettings = state.rPages.helperSettings || {};
    const userHelperSettings = helperSettings[userId] || {};
    dispatch(ActionPagesUpdateState('helperSettings', {
      ...helperSettings,
      [userId]: {
        ...userHelperSettings,
        [type]: helperState,
      },
    }));
  };
}

export function ActionToggleSidebar() {
  return (dispatch, getState) => {
    const state = getState().rPages || {};

    dispatch(ActionPagesUpdateState('hideSidebar', !state.hideSidebar));
    dispatch(ActionPagesUpdateState('hideInfoBar', true));
  };
}

export function ActionCloseSidebar() {
  return (dispatch) => {
    dispatch(ActionPagesUpdateState('hideSidebar', true));
  };
}

export function ActionToggleInfoBar() {
  return (dispatch, getState) => {
    const state = getState().rPages || {};

    dispatch(ActionPagesUpdateState('hideInfoBar', !state.hideInfoBar));
    dispatch(ActionPagesUpdateState('hideSidebar', true));
  };
}

export function ActionChangeLanguage(language) {
  return (dispatch) => {
    dispatch(ActionPagesUpdateState('language', language));
  };
}

export function ActionHideCookiesNotification() {
  return (dispatch) => {
    dispatch(ActionPagesUpdateState('hideCookiesNotification', true));
  };
}

export function ActionGetNewVideoPollsCounter() {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.rUser || {};
    const userRole = user.role;

    if (userRole === USER_ROLE.CANDIDATE) {
      return getUnreadCountVideoPollsCandidate().then((res) => {
        dispatch(ActionStoreServerData('newVideoPolls', res.count));
      });
    }

    if (userRole === USER_ROLE.EMPLOYER || userRole === USER_ROLE.RECRUITER
      || userRole === USER_ROLE.ASSISTANT) {
      return getUnreadCountVideoPollsEmployer().then((res) => {
        dispatch(ActionStoreServerData('newVideoPolls', res.count));
      });
    }
  };
}
